import React, { useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ContextMenu, { Position } from "devextreme-react/context-menu";
import List from "devextreme-react/list";
import { useAuth } from "../../contexts/auth";
import "./UserPanel.scss";
import defaultProfilePic from "../../assets/profilepic.jpg";

export default function UserPanel({ menuMode }) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const navigateToProfile = useCallback(() => {
    if (user.userrole == "customer") {
      navigate("/CustomerProfile");
    } else if (user.userrole == "company") {
      navigate("/CompanyProfile");
    } else if (user.userrole == "customercontact") {
      navigate("/CustomerContactProfile");
    } else {
      /// profile for company user
      navigate("/Profile");
    }
  }, [navigate]);

  //Function to capitalize the First Letter of the Logged In User:
  const capitalizeFirst = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const menuItems = useMemo(
    () => [
      {
        text: "Profile",
        icon: "user",
        onClick: navigateToProfile,
      },
      {
        text: "Logout",
        icon: "runner",
        onClick: signOut,
      },
    ],
    [navigateToProfile, signOut],
  );

  return (
    <div className={"user-panel"}>
      <div className={"user-info"}>
        <div className={"image-container"}>
          {/* //// user logo changes here */}
          <img
            src={
              user?.custlogo ||
              user?.companyavatar ||
              user?.userlogo ||
              user?.contactlogo
                ? `data:image/png;base64,${
                    user?.custlogo ||
                    user?.companyavatar ||
                    user?.userlogo ||
                    user?.contactlogo
                  }`
                : defaultProfilePic
            }
            alt=""
            style={{ height: "28px", width: "28px", borderRadius: "50%" }}
          />
        </div>

        <div
          className="user-name-info"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "40px",
            // gap: "20px",
            alignItems: "flex-start",
            justifyContent: "space-around",
            // fontFamily: "inter",
          }}
        >
          <div
            className={"user-name"}
            style={{ color: "#344450", fontWeight: "700", fontFamily: "inter" }}
          >
            {capitalizeFirst(user.login_name) ||
              user?.email?.split("@")[0] ||
              "Username"}
          </div>
          {/* <div
            className={"user-name"}
            style={{ color: "#687787", fontStyle: "italic", fontSize: "12px" }}
          >
            Last sync at 11:52 am
          </div> */}
        </div>

        <div className="keydown">
          <i className="ri-arrow-down-s-line" style={{ fontSize: "20px" }}></i>
        </div>
      </div>

      {menuMode === "context" && (
        <ContextMenu
          items={menuItems}
          target={".user-button"}
          showEvent={"dxclick"}
          width={210}
          cssClass={"user-menu"}
        >
          <Position
            my={{ x: "center", y: "top" }}
            at={{ x: "center", y: "bottom" }}
          />
        </ContextMenu>
      )}
      {menuMode === "list" && (
        <List className={"dx-toolbar-menu-action"} items={menuItems} />
      )}
    </div>
  );
}
